import { Component, Input, OnInit } from '@angular/core';
import { PaymentsStoreService } from '../services/payments-store.service';

@Component({
  selector: 'app-select-chart',
  templateUrl: './select-chart.component.html',
  styleUrls: ['./select-chart.component.scss']
})
export class SelectChartComponent implements OnInit {

  @Input() selectOptions: any[] = [];
  @Input() name: string = 'selectedChart';
  @Input() label: string = 'Reporte';
  @Input() required: boolean = true;
  @Input() show: boolean = true;
  @Input() minlength: number = 3;
  @Input() selection: string = '';


  constructor(private store: PaymentsStoreService) { this.noOptions(); }

  ngOnInit() {
  }

  noOptions() {
    if (!this.selectOptions || this.selectOptions.length <= 0) {
      this.selectOptions = [
        { value: 'onlinePayments', label: 'Pagos online' },
        { value: 'bankPayments', label: 'Pagos bancarios por día' },
      ];
    }
  }

  handleSelect() {
    this.store.setSelectState(this.selection);
  }

}
